import classNames from 'clsx';
import React from 'react';

import type { Props as ModalProps } from '../Modal/Modal';
import Modal from '../Modal/Modal';

import styles from './HelpModal.scss';

interface HelpModalProps extends ModalProps {
  variant?: 'contentOverlay';
}

const HelpModal: React.FC<HelpModalProps> = ({ children, variant, ...props }) => (
  <Modal {...props}>
    <div className={classNames(styles.content, variant && styles[variant])}>{children}</div>
  </Modal>
);

export default HelpModal;
